import DeleteEvent from "./DeleteEvent";

export default DeleteEvent